/* Nyigen mobile marquee. No changes to Ignite core. */
(() => {
  'use strict';

  const MEDIA = window.matchMedia('(max-width: 749px)');
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ACTIVE = 'nyigen-icons-marquee-active';
  const CLONE = 'nyigen-icons-marquee-clone';
  const SELECTOR = '.icons-with-text slider-component';
  const initialized = new WeakMap();
  let resizeFrame = 0;

  function clear(component) {
    const slider = component.querySelector(':scope > ul.slider');
    if (!slider) return;
    component.classList.remove(ACTIVE);
    slider.querySelectorAll(`.${CLONE}`).forEach((element) => element.remove());
    slider.style.removeProperty('--nyigen-icons-marquee-distance');
    slider.style.removeProperty('--nyigen-icons-marquee-duration');
    initialized.delete(component);
  }

  function duplicate(original) {
    const copy = original.cloneNode(true);
    copy.classList.add(CLONE);
    copy.removeAttribute('id');
    copy.removeAttribute('data-shopify-editor-block');
    copy.setAttribute('aria-hidden', 'true');
    copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
    copy.querySelectorAll('a, button, input, select, textarea, [tabindex]')
      .forEach((node) => node.setAttribute('tabindex', '-1'));
    return copy;
  }

  function setup(component) {
    const slider = component.querySelector(':scope > ul.slider.slider--tablet');
    if (!slider || !MEDIA.matches || REDUCED_MOTION.matches) {
      if (initialized.has(component)) clear(component);
      return;
    }

    const originals = Array.from(slider.children).filter((node) =>
      node.classList.contains('slider__slide') && !node.classList.contains(CLONE)
    );
    if (originals.length < 2) {
      if (initialized.has(component)) clear(component);
      return;
    }

    // Avoid rebuilding when the viewport width has not changed.
    const width = component.clientWidth;
    if (initialized.get(component) === width && component.classList.contains(ACTIVE)) return;
    clear(component);

    // Measure one complete run in its final CSS layout before cloning.
    const start = originals[0].getBoundingClientRect().left;
    const end = originals[originals.length - 1].getBoundingClientRect().right;
    const lastStyle = getComputedStyle(originals[originals.length - 1]);
    const pad = parseFloat(lastStyle.paddingRight) || 0;
    const distance = end - start;
    if (!Number.isFinite(distance) || distance <= 0) return;

    const fragment = document.createDocumentFragment();
    originals.forEach((node) => fragment.appendChild(duplicate(node)));
    slider.appendChild(fragment);

    // Check actual clone position: includes any native layout gap.
    const clone = slider.querySelector(`.${CLONE}`);
    const actualDistance = clone ? clone.getBoundingClientRect().left - start : distance + pad;
    if (!Number.isFinite(actualDistance) || actualDistance <= 0) {
      clear(component);
      return;
    }

    slider.style.setProperty('--nyigen-icons-marquee-distance', `${actualDistance}px`);
    slider.style.setProperty('--nyigen-icons-marquee-duration', `${Math.max(20, actualDistance / 45)}s`);
    component.classList.add(ACTIVE);
    initialized.set(component, width);
  }

  function all(scope = document) {
    if (scope.matches && scope.matches(SELECTOR)) setup(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(setup);
  }

  function onResize() {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => {
      resizeFrame = 0;
      all();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => all(), { once: true });
  } else {
    all();
  }
  window.addEventListener('resize', onResize, { passive: true });
  MEDIA.addEventListener('change', onResize);
  REDUCED_MOTION.addEventListener('change', onResize);
  document.addEventListener('shopify:section:load', (event) => all(event.target));
  document.addEventListener('shopify:section:reorder', () => all());
})();